import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Button, Card, Col, Input, Modal, Row, Select } from 'antd'
import { useSelector } from 'react-redux'
import { formatMessageNew, handleChange } from '@/utils/common'
import { readNfcUid } from '@/services/tag/tag'
import {
  findBatchNumberByPlant,
  findPlantModules,
  getProductCodeByUpc,
  scanBatchDetail,
  withdrawBatchDetail
} from '@/services/writeOff/writeOff'
import { modalConfirm, modalError } from '@/utils/modalUtils'
import { useHistory, useLocation } from 'react-router-dom'
import TipImg from '@/assets/images/tip.png'
import { clearAuthentication } from '../../utils/authHelp'

const UIDCollection = () => {
  const history = useHistory()
  const inputRef = useRef(null)
  const inputUpcRef = useRef(null)
  const [isNoResponseActive, setNoResponseIsActive] = useState(false)
  const [isActiveNoPhysicalBuckle, setIsActiveNoPhysicalBuckle] = useState(false)
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const [themeObj] = useState({ width: 500 * deviceSize, padding: 16 * deviceSize })
  const [functionPlantOptions, setFunctionPlantOptions] = useState([])
  const [functionBatchNoOptions, setFunctionBatchNoOptions] = useState([])
  const [visibleFlag, setVisibleFlag] = useState(false)
  const [upcVisibleFlag, setUpcVisibleFlag] = useState(false)
  const [batchNo, setBatchNo] = useState('')
  const [plant, setPlant] = useState('')
  const [nfcUid, setNfcUid] = useState('')
  const [upc, setUpc] = useState('')
  const [scanType, setScanType] = useState('') // NFC标签类型
  const [skuSize, setSkuSize] = useState('') // NFC标签类型
  const [recordCount, setRecordCount] = useState(0) // NFC标签类型
  const [successFlag, setSuccessFlag] = useState(false) // 控制成功弹窗
  const [undoSuccessFlag, setUndoSuccessFlag] = useState(false)
  const [lastScanType, setLastScanType] = useState('')
  const [lastScanValue, setLastScanValue] = useState('')
  const languageState = useSelector(state => state.commonStore.language)
  const workstationState = useSelector(state => state.commonStore.workstation)
  const macState = useSelector(state => state.commonStore.mac)
  const errorNumRef = useRef(0)
  const intervalRef = useRef(null)
  const lastSendDataRef = useRef({ upc: '', nfcUid: '' })
  const lastWithdrawDataRef = useRef({ batchNo: '', scannerId: '', upc: '', exception: '' })
  const fetNFCFunRef = useRef()
  const scanBatchDetailFunRef = useRef()
  const [upcDisibleFlag, setUpcDisibleFlag] = useState(false)
  const [upcComfirmDisibleFlag, setUpcComfirmDisibleFlag] = useState(false)
  const location = useLocation()

  useEffect(() => {
    // 防止切换语言后重复NFC报错不切换
    clearTimeout(intervalRef.current)
    // 启用定时器
    intervalRef.current = setTimeout(() => fetNFCFunRef.current(), 1400)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageState])
  useEffect(() => {
    findPlantModulesFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    return () => {
      clearTimeout(intervalRef.current)
      console.log('清除定时器')
    }
  }, [])

  useEffect(() => {
    return () => {
      clearTimeout(intervalRef.current)
    }
  }, [location.pathname])

  useEffect(() => {
    if (!macState) {
      if (errorNumRef.current === 0) {
        errorNumRef.current = 1
        modalConfirm(
          {
            content: formatMessageNew('languageObj.nsptagLocale.macError'),
            cancelText: formatMessageNew('languageObj.nsptagLocale.backText'),
            okText: formatMessageNew('languageObj.nsptagLocale.loginText'),
            onCancel: () => {
              errorNumRef.current = 0
              history.goBack()
            }
          },
          () => {
            errorNumRef.current = 0
            clearAuthentication()
            history.push('/login')
          }
        )
      }
      return
    }
    if (!workstationState) {
      if (errorNumRef.current === 0) {
        errorNumRef.current = 1
        modalConfirm(
          {
            content: formatMessageNew('languageObj.nsptagLocale.workstationError'),
            cancelText: formatMessageNew('languageObj.nsptagLocale.backText'),
            okText: formatMessageNew('languageObj.nsptagLocale.loginText'),
            onCancel: () => {
              errorNumRef.current = 0
              history.goBack()
            }
          },
          () => {
            errorNumRef.current = 0
            clearAuthentication()
            history.push('/login')
          }
        )
      }
      return
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intervalRef.current])

  const findPlantModulesFun = () => {
    let param = {
      isConfig: false
    }
    findPlantModules(param).then(res => {
      let ls = res.resultData.map(item => {
        return {
          label: item,
          value: item
        }
      })
      setFunctionPlantOptions(ls)
    })
  }

  const findBatchNumberByPlantFun = plant => {
    setPlant(plant)
    let param = {
      plant: plant
    }
    findBatchNumberByPlant(param).then(res => {
      let ls = res.resultData.map(item => {
        return {
          label: item,
          value: item
        }
      })
      setFunctionBatchNoOptions(ls)
    })
  }

  // 串行读取NFC UID，异常弹窗时中断后续调用
  const fetNFCFun = useCallback(() => {
    // 如果已弹窗，直接中断，不再继续读取
    if (errorNumRef.current !== 0) return
    // 调用接口读取NFC UID
    readNfcUid({})
      .then(response => {
        let res = response.resultData
        // 接口返回成功
        if (response.errorcode === '200') {
          if (res && res.length > 0) {
            // 读到多个NFC标签，异常处理
            if (res.length > 1) {
              resetNfcUidValue() // 清空NFC UID
              clearTimeout(intervalRef.current)
              if (errorNumRef.current === 0) {
                errorNumRef.current = 1 // 标记弹窗已触发
                modalError(
                  {
                    content: formatMessageNew('languageObj.nsptagLocale.multipleNfcError')
                  },
                  () => {
                    errorNumRef.current = 0 // 关闭弹窗后重置标记
                    // 继续下一次读取
                    if (visibleFlag) {
                      clearTimeout(intervalRef.current)
                      intervalRef.current = setTimeout(() => fetNFCFunRef.current(), 1400)
                    }
                  }
                )
              }
            } else {
              // 正常只读到一个NFC标签
              setNfcUid(res[0].UID)
              setTimeout(() => scanBatchDetailFunRef.current(), 0)
            }
          } else {
            if (visibleFlag) {
              clearTimeout(intervalRef.current)
              intervalRef.current = setTimeout(() => fetNFCFunRef.current(), 1400)
            }
          }
        } else {
          // 接口返回异常，弹窗提示
          resetNfcUidValue()
          if (errorNumRef.current === 0) {
            errorNumRef.current = 1
            modalConfirm(
              {
                content: formatMessageNew('languageObj.nsptagLocale.macError'),
                cancelText: formatMessageNew('languageObj.nsptagLocale.backText'),
                okText: formatMessageNew('languageObj.nsptagLocale.loginText'),
                onCancel: () => {
                  errorNumRef.current = 0
                  history.goBack()
                }
              },
              () => {
                errorNumRef.current = 0
                clearAuthentication()
                history.push('/login')
              }
            )
          }
        }
      })
      .catch(error => {
        // 弹窗提示
        if (errorNumRef.current === 0) {
          errorNumRef.current = 1
          modalConfirm(
            {
              content: formatMessageNew('languageObj.nsptagLocale.macError'),
              cancelText: formatMessageNew('languageObj.nsptagLocale.backText'),
              okText: formatMessageNew('languageObj.nsptagLocale.loginText'),
              onCancel: () => {
                errorNumRef.current = 0
                history.goBack()
              }
            },
            () => {
              errorNumRef.current = 0
              clearAuthentication()
              history.push('/login')
            }
          )
        }
      })
  }, [history, visibleFlag])

  const scanBatchDetailFun = useCallback(
    (force = false) => {
      //只有非强制时才判断数据一致性
      if (!force && nfcUid !== '' && lastSendDataRef.current.nfcUid === nfcUid) {
        clearTimeout(intervalRef.current)
        intervalRef.current = setTimeout(() => fetNFCFunRef.current(), 1400)
        return // 一致则不再发送
      }
      // 更新为本次数据
      lastSendDataRef.current = { upc, nfcUid }
      clearTimeout(intervalRef.current)
      const params = {
        batchNo,
        uid: nfcUid.trim(),
        scannerId: localStorage.getItem('userName') || '',
        upc: upc.trim(),
        exception: scanType
      }
      scanBatchDetail(params)
        .then(res => {
          if (res.errorCode === '200') {
            lastWithdrawDataRef.current = upc.trim()
              ? {
                  batchNo,
                  scannerId: localStorage.getItem('userName') || '',
                  upc: upc.trim(),
                  exception: scanType
                }
              : { batchNo: '', scannerId: '', upc: '', exception: '' }
            setRecordCount(prev => prev + 1)
            setLastScanType(upc.trim() ? 'UPC' : 'UID')
            setLastScanValue(upc.trim() ? skuSize || upc.trim() : nfcUid.trim())
            setUndoSuccessFlag(false)
            setSuccessFlag(true)
            hideUpcModal()
            setTimeout(() => setSuccessFlag(false), 2000)
            if (visibleFlag) {
              clearTimeout(intervalRef.current)
              intervalRef.current = setTimeout(() => fetNFCFunRef.current(), 1400)
            }
          }
        })
        .catch(error => {
          clearTimeout(intervalRef.current)
          if (errorNumRef.current !== 0) return
          errorNumRef.current = 1
          console.error('接口异常:', error) // 打印 error 结构
          let str = ''
          // 兼容 error 可能为字符串、对象等情况
          const code = (error && error.errorCode) || (typeof error === 'string' ? error : undefined)
          const resultData = error && error.resultData ? error.resultData : ''
          switch (code) {
            case '2207':
              str = formatMessageNew('languageObj.writeOff.error_code_2207')
              break
            case '2208':
              str = formatMessageNew('languageObj.writeOff.error_code_2208')
              break
            case '2209':
              str =
                formatMessageNew('languageObj.writeOff.error_code_2209_fon') +
                ' ' +
                (typeof resultData === 'string' ? resultData : JSON.stringify(resultData || '')) +
                ' ' +
                formatMessageNew('languageObj.writeOff.error_code_2209_bac')
              break
            case '2210':
              str =
                formatMessageNew('languageObj.writeOff.error_code_2210_fon') +
                ' ' +
                (typeof resultData === 'string' ? resultData : JSON.stringify(resultData || '')) +
                ' ' +
                formatMessageNew('languageObj.writeOff.error_code_2210_bac')
              break
            case '2211':
              str = formatMessageNew('languageObj.writeOff.error_code_2211')
              break
            default:
              str = formatMessageNew('languageObj.httpLocale.requestError')
          }
          modalError(
            {
              content: str
            },
            () => {
              errorNumRef.current = 0
              if (visibleFlag) {
                clearTimeout(intervalRef.current)
                intervalRef.current = setTimeout(() => fetNFCFunRef.current(), 1400)
              }
            }
          )
        })
    },
    [upc, nfcUid, batchNo, scanType, visibleFlag, skuSize]
  )

  useEffect(() => {
    fetNFCFunRef.current = fetNFCFun
    scanBatchDetailFunRef.current = scanBatchDetailFun
  }, [fetNFCFun, scanBatchDetailFun])

  // 弹窗显示时启动，关闭时清除
  useEffect(() => {
    if (visibleFlag) {
      fetNFCFunRef.current = fetNFCFun
      fetNFCFunRef.current() // 弹窗显示时主动启动 NFC 读取
    } else {
      clearTimeout(intervalRef.current)
    }
    return () => clearTimeout(intervalRef.current)
  }, [fetNFCFun, visibleFlag])

  useEffect(() => {
    // 只要 visibleFlag 为 true 且 upcVisibleFlag 为 false，聚焦 inputRef
    if (visibleFlag && !upcVisibleFlag) {
      inputRef.current && inputRef.current.focus({ cursor: 'all' })
    }
  }, [visibleFlag, upcVisibleFlag])

  useEffect(() => {
    // upcVisibleFlag 为 true 时，延迟聚焦 inputUpcRef，确保 Modal 已渲染
    if (visibleFlag && upcVisibleFlag) {
      setTimeout(() => {
        inputUpcRef.current && inputUpcRef.current.focus({ cursor: 'all' })
      }, 100)
    }
  }, [upcVisibleFlag, visibleFlag])

  const resetNfcUidValue = () => {
    setNfcUid('')
  }

  const getProductCodeByUpcFun = () => {
    if (upc === '') {
      return
    }
    let param = { upc }
    getProductCodeByUpc(param)
      .then(res => {
        if (res.errorCode === '200') {
          setSkuSize(res.resultData)
          setUpcDisibleFlag(true)
          setUpcComfirmDisibleFlag(false)
        }
      })
      .catch(() => {
        modalError(
          {
            content: formatMessageNew('languageObj.writeOff.error_code_2211')
          },
          () => {
            errorNumRef.current = 0
            setUpcComfirmDisibleFlag(true)
          }
        )
      })
  }

  const onBlurFun = e => {
    // 失焦后自动聚焦 inputUpcRef（仅在 upcVisibleFlag 为 true 时）
    if (upcVisibleFlag) {
      setTimeout(() => {
        inputUpcRef.current && inputUpcRef.current.focus({ cursor: 'all' })
      }, 500)
    }
  }

  const onInputBlurFun = e => {
    // 失焦后自动聚焦 inputRef（仅在 visibleFlag 为 true 且 upcVisibleFlag 为 false 时）
    if (visibleFlag && !upcVisibleFlag) {
      setTimeout(() => {
        inputRef.current && inputRef.current.focus({ cursor: 'all' })
      }, 500)
    }
  }

  const hideEditModal = () => {
    setVisibleFlag(false)
    setBatchNo('')
    setPlant('')
    setNfcUid('')
    setRecordCount(0)
    setLastScanType('')
    setLastScanValue('')
    lastWithdrawDataRef.current = { batchNo: '', scannerId: '', upc: '', exception: '' }
    setUndoSuccessFlag(false)
    setFunctionBatchNoOptions([])
  }

  const handleUndo = () => {
    if (lastScanType !== 'UPC') return
    withdrawBatchDetail(lastWithdrawDataRef.current)
      .then(res => {
        if (res.errorCode === '200') {
          setRecordCount(prev => Math.max(prev - 1, 0))
          setLastScanType('')
          setLastScanValue('')
          lastWithdrawDataRef.current = { batchNo: '', scannerId: '', upc: '', exception: '' }
          setSuccessFlag(false)
          setUndoSuccessFlag(true)
          setTimeout(() => setUndoSuccessFlag(false), 2000)
        }
      })
      .catch(error => {
        modalError({
          content: (error && error.errorMessage) || formatMessageNew('languageObj.httpLocale.requestError')
        })
      })
  }

  // NFC输入框回车事件
  const onInputKeyDownNfc = e => {
    if (e.keyCode !== 13) return
    inputRef.current.blur()
    scanBatchDetailFunRef.current(true) // 强制发送
  }

  // UPC输入框回车事件
  const onKeyDownUpc = e => {
    if (e.keyCode === 13 && upcDisibleFlag === false) {
      inputUpcRef.current.blur()
      getProductCodeByUpcFun()
    }
  }

  const showUpcModal = () => {
    setUpcVisibleFlag(true) // 打开弹窗
    setUpcDisibleFlag(false)
    setSkuSize('') // 清空 skuSize
    setUpc('') // 清空 upc
    setUpcComfirmDisibleFlag(true)
    clearTimeout(intervalRef.current)
    inputUpcRef.current && inputUpcRef.current.focus({ cursor: 'all' })
  }

  const hideUpcModal = () => {
    setUpcVisibleFlag(false)
    setNoResponseIsActive(false)
    setIsActiveNoPhysicalBuckle(false)
    setSkuSize('')
    setUpc('')
    setScanType('')
    clearTimeout(intervalRef.current)
    intervalRef.current = setTimeout(() => fetNFCFunRef.current(), 1400)
    setUpcComfirmDisibleFlag(false)
    inputRef.current && inputRef.current.focus({ cursor: 'all' })
  }

  return (
    <div>
      {!visibleFlag && (
        <div className="tag-container mt20" style={{ height: 'auto' }}>
          <Card style={themeObj} className="nfc_card">
            <div style={{ maxWidth: 680 }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
                <span style={{ width: 240, textAlign: 'left', marginRight: 8 }}>
                  <span style={{ color: 'red', marginRight: 4 }}>*</span>
                  {formatMessageNew('languageObj.writeOff.plantCode')}：
                </span>
                <Select
                  allowClear
                  style={{ width: '100%' }}
                  placeholder={formatMessageNew('languageObj.commonLocale.placeholderSelect')}
                  options={functionPlantOptions}
                  value={plant}
                  onChange={value => {
                    setPlant(value)
                    findBatchNumberByPlantFun(value)
                    setBatchNo('') // 切换工厂时清空批次
                  }}
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
                <span style={{ width: 240, textAlign: 'left', marginRight: 8 }}>
                  <span style={{ color: 'red', marginRight: 4 }}>*</span>
                  {formatMessageNew('languageObj.writeOff.batchNumber')}：
                </span>
                <Select
                  allowClear
                  style={{ width: '100%' }}
                  disabled={functionBatchNoOptions.length === 0}
                  placeholder={formatMessageNew('languageObj.commonLocale.placeholderSelect')}
                  options={functionBatchNoOptions}
                  value={batchNo}
                  onChange={value => setBatchNo(value)}
                />
              </div>
              <div
                style={{
                  margin: '16px 0',
                  color: '#888',
                  textAlign: 'left'
                }}
              >
                {formatMessageNew('languageObj.writeOff.scanWarnFron')}
              </div>
              <Row>
                <Col push={7} span={10}>
                  <div className="displayFlex alignCenter justifyContentCenter mt20">
                    <Button
                      onClick={() => setVisibleFlag(true)}
                      className="reset-btn mt0"
                      disabled={!plant || !batchNo}
                      style={{
                        width: '100%',
                        fontSize: 20,
                        fontWeight: 500,
                        height: 'auto',
                        padding: 12,
                        lineHeight: 1
                      }}
                    >
                      {formatMessageNew('languageObj.writeOff.enterScan')}
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Card>
        </div>
      )}
      {visibleFlag && (
        <div className="tag-container mt20" style={{ height: 'auto' }}>
          <Card style={themeObj} className="nfc_card">
            <div>
              {successFlag && (
                <Row gutter={16} justify="center">
                  <Col span={18} style={{ textAlign: 'right' }}>
                    <div
                      className="modal_wrapper nike_confirm"
                      style={{
                        width: '100%',
                        border: '2px solid #52c41a',
                        color: '#000',
                        borderRadius: 10,
                        padding: '10px 16px',
                        textAlign: 'center',
                        background: '#fff',
                        userSelect: 'none',
                        fontWeight: '650',
                        fontSize: 22
                      }}
                    >
                      {formatMessageNew('languageObj.writeOff.scanSuccess')}
                    </div>
                  </Col>
                </Row>
              )}
              {undoSuccessFlag && (
                <Row gutter={16} justify="center">
                  <Col span={18} style={{ textAlign: 'right' }}>
                    <div
                      className="modal_wrapper nike_confirm"
                      style={{
                        width: '100%',
                        border: '2px solid #52c41a',
                        color: '#000',
                        borderRadius: 10,
                        padding: '10px 16px',
                        textAlign: 'center',
                        background: '#fff',
                        userSelect: 'none',
                        fontWeight: '650',
                        fontSize: 22
                      }}
                    >
                      {formatMessageNew('languageObj.writeOff.undoSuccess')}
                    </div>
                  </Col>
                </Row>
              )}
              <div style={{ marginTop: 24, display: 'flex', alignItems: 'center' }}>
                <span style={{ width: 240, textAlign: 'left', marginRight: 8 }}>
                  {formatMessageNew('languageObj.writeOff.batchNumber')}：
                </span>
                <Input
                  value={batchNo}
                  readOnly
                  bordered={false}
                  placeholder={formatMessageNew('languageObj.commonLocale.placeholderScanInput')}
                  style={{ width: '100%', borderRadius: 10, border: 'none', background: 'transparent' }}
                  disabled={false}
                />
              </div>
              <div style={{ marginTop: 24, display: 'flex', alignItems: 'center' }}>
                <span style={{ width: 240, textAlign: 'left', marginRight: 8 }}>
                  {formatMessageNew('languageObj.writeOff.nfcUid')}：
                </span>
                <Input
                  ref={inputRef}
                  allowClear
                  value={nfcUid}
                  onBlur={e => onInputBlurFun(e)}
                  onChange={e => {
                    setNfcUid(e.target.value)
                  }}
                  onKeyUp={e => {
                    onInputKeyDownNfc(e)
                  }}
                  placeholder={formatMessageNew('languageObj.commonLocale.placeholderScanInput')}
                  style={{ width: '100%', borderRadius: 10 }}
                />
              </div>
              <div style={{ marginLeft: '40px' }} className="displayFlex alignCenter justifyContentCenter">
                <img className="tipImg" alt="tip" src={TipImg} />
                {formatMessageNew('languageObj.reprint.inputTip')}
              </div>
              <Row gutter={16} style={{ marginTop: 24 }}>
                <Col span={12}>
                  <Button
                    className="modal_wrapper nike_confirm"
                    style={{
                      width: '100%',
                      border: nfcUid ? '1px solid #000' : '1px solid #ff9800',
                      color: nfcUid ? '#bbb' : isNoResponseActive ? '#fff' : '#000',
                      background: nfcUid ? '#f5f5f5' : isNoResponseActive ? '#ff9800' : 'transparent',
                      borderRadius: 10,
                      fontWeight: 500,
                      cursor: nfcUid ? 'not-allowed' : 'pointer'
                    }}
                    disabled={!!nfcUid}
                    onClick={() => {
                      showUpcModal()
                      setNoResponseIsActive(true)
                      setScanType('Scan Not Response Tag')
                    }}
                  >
                    {formatMessageNew('languageObj.writeOff.noResponse')}
                  </Button>
                </Col>
                <Col span={12}>
                  <Button
                    className="modal_wrapper nike_confirm"
                    style={{
                      width: '100%',
                      border: nfcUid ? '1px solid #000' : '1px solid #ff9800',
                      color: nfcUid ? '#bbb' : isActiveNoPhysicalBuckle ? '#fff' : '#000',
                      background: nfcUid ? '#f5f5f5' : isActiveNoPhysicalBuckle ? '#ff9800' : 'transparent',
                      borderRadius: 10,
                      fontWeight: 500,
                      cursor: nfcUid ? 'not-allowed' : 'pointer'
                    }}
                    disabled={!!nfcUid}
                    onClick={() => {
                      showUpcModal()
                      setIsActiveNoPhysicalBuckle(true)
                      setScanType('No NFC Tag')
                    }}
                  >
                    {formatMessageNew('languageObj.writeOff.noPhysicalBuckle')}
                  </Button>
                </Col>
              </Row>
              <Row gutter={16} style={{ marginTop: 60, marginBottom: 25 }}>
                <Col span={12} style={{ fontWeight: 600 }}>
                  <span style={{ display: 'block', marginBottom: 8 }}>
                    {formatMessageNew('languageObj.writeOff.lastScan')}
                  </span>
                  <span>
                    {lastScanValue ? `${lastScanType === 'UID' ? 'NFC UID' : 'SKU'}: ${lastScanValue}` : '--'}
                  </span>
                </Col>
                <Col span={12} style={{ textAlign: 'right', marginTop: 10 }}>
                  <Button
                    className="modal_wrapper nike_confirm"
                    disabled={lastScanType !== 'UPC'}
                    onClick={handleUndo}
                    style={{
                      width: '40%',
                      border: lastScanType === 'UPC' ? '1px solid #ff9800' : '1px solid #000',
                      color: lastScanType === 'UPC' ? '#ff9800' : '#999',
                      borderRadius: 10,
                      fontWeight: 500,
                      background: '#fff',
                      cursor: lastScanType === 'UPC' ? 'pointer' : 'not-allowed'
                    }}
                  >
                    {formatMessageNew('languageObj.writeOff.undo')}
                  </Button>
                </Col>
              </Row>
              <Row gutter={16} style={{ marginBottom: 25 }} justify="end">
                <Col span={12} style={{ fontWeight: 600 }}>
                  <span>{formatMessageNew('languageObj.writeOff.scanCount')}：</span>
                  <span>{recordCount}</span>
                </Col>
              </Row>
              <Row gutter={16} justify="end">
                <Col span={12} style={{ textAlign: 'left' }}>
                  <Button
                    onClick={hideEditModal}
                    className="reset-btn mt0"
                    style={{
                      width: '100%',
                      fontSize: 20,
                      fontWeight: 500,
                      height: 'auto',
                      padding: 12,
                      lineHeight: 1
                    }}
                  >
                    {formatMessageNew('languageObj.writeOff.back')}
                  </Button>
                </Col>
              </Row>
            </div>
          </Card>
        </div>
      )}
      <Modal
        open={upcVisibleFlag}
        maskClosable={false}
        className="nike_modal"
        width="30%"
        closable={false}
        onCancel={hideUpcModal}
        style={{ left: '8.5%', top: '240px' }}
        footer={null}
      >
        <div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ width: 120, textAlign: 'center', marginRight: 8 }}>
              {formatMessageNew('languageObj.writeOff.upc')}：
            </span>
            <Input
              allowClear
              value={upc}
              ref={inputUpcRef}
              onKeyUp={e => onKeyDownUpc(e)}
              onBlur={e => onBlurFun(e)}
              disabled={upcDisibleFlag}
              placeholder={formatMessageNew('languageObj.commonLocale.placeholderScanInput')}
              maxlength={14}
              onChange={e =>
                handleChange(e, {
                  setState: value => {
                    setUpc(value)
                  }
                })
              }
              style={{ width: '100%', float: 'center', borderRadius: 10 }}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
            <span style={{ color: '#40a9ff', width: 210, textAlign: 'right', marginRight: 8, fontSize: '18px' }}>
              {skuSize}
            </span>
          </div>
          <Row gutter={16}>
            <Col span={12}>
              <Button
                className="modal_wrapper nike_confirm"
                style={{
                  width: '100%',
                  border: upcComfirmDisibleFlag ? '1px solid #000' : '1px solid #ff9800',
                  color: '#000',
                  borderRadius: 10,
                  fontWeight: 500
                }}
                disabled={upcComfirmDisibleFlag}
                onClick={() => scanBatchDetailFunRef.current()}
              >
                {formatMessageNew('languageObj.writeOff.confirm')}
              </Button>
            </Col>
            <Col span={12}>
              <Button
                onClick={hideUpcModal}
                className="reset-btn mt0"
                style={{
                  width: '100%',
                  fontSize: 20,
                  fontWeight: 500,
                  height: 'auto',
                  padding: 12,
                  borderRadius: 10,
                  lineHeight: 1
                }}
              >
                {formatMessageNew('languageObj.writeOff.back')}
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  )
}
export default UIDCollection
